/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import isNil from 'lodash/isNil';

import ErrorName from '../../error/error-name';

/**
 * Správce času a časových zón pro standardní webové technologie.
 * @implements {TimeManager}
 */
class WebTimeManager {
  /** @inheritdoc */
  getZone() {
    return new Promise((resolve) => {
      try {
        const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (isNil(zone)) {
          throw new Error('Missing time zone.');
        }
        return resolve(zone);
      } catch (error) {
        error.name = ErrorName.NotSupportedError;
        throw error;
      }
    });
  }
}

export default WebTimeManager;
